import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-support-id',
  templateUrl: './support-id.component.html',
  styleUrls: ['./support-id.component.scss'],
})
export class SupportIdComponent {
  @Input() value: string | number | null | undefined = null;
  @Input() label: string = 'ID';

  public get displayValue(): string {
    return this.value === null || this.value === undefined || this.value === ''
      ? '-'
      : String(this.value);
  }

  public get isCopyable(): boolean {
    return this.displayValue !== '-';
  }

  public get tooltip(): string {
    return this.isCopyable
      ? `Copiar ${this.label}: ${this.displayValue}`
      : `Sin ${this.label}`;
  }

  public stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
  }
}
